<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <!--<a-col :span="24">
            <a-form-model-item label="栏目id" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colId">
              <a-input v-model="model.colId" placeholder="请输入栏目id"  ></a-input>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item label="栏目" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colCode">
              <a-input v-model="model.colName" placeholder="请输入栏目"  ></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item label="内容id" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentId">
              <a-input v-model="model.contentId" placeholder="请输入内容id"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="内容code" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentCode">
              <a-input v-model="model.contentCode" placeholder="请输入内容code"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="内容名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentName">
              <a-input v-model="model.contentName" placeholder="请输入内容名称"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input v-model="model.sortNo" placeholder="请输入排序"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="状态(published:已发布；nupublished:未发布)" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
              <a-input v-model="model.status" placeholder="请输入状态(published:已发布；nupublished:未发布)"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="发布时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishedTime">
              <j-date placeholder="请选择发布时间" v-model="model.publishedTime"  style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="发布人id" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishedUserId">
              <a-input v-model="model.publishedUserId" placeholder="请输入发布人id"  ></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'EmpzoneColContentForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/colContent/empzonecolcontent",
          edit: "/colContent/empzonecolcontent",
          queryById: "/colContent/empzonecolcontent/"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add (colId,colCode,colName) {
        this.modelDefault.colId = colId
        this.modelDefault.colCode = colCode
        this.modelDefault.colName = colName
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
